import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { IAdminModalComponent, IAdminModalData } from '../../domain/models/admin-modal';
import { duplicateControlError } from '@shared/validators';

@Component({
	selector: 'app-admin-update-emails-modal',
	templateUrl: './admin-update-emails-modal.component.html',
	styleUrls: ['./admin-update-emails-modal.component.scss'],
})
export class AdminUpdateEmailsModalComponent implements IAdminModalComponent, OnInit {
	@Input() data: IAdminModalData<{}>;
	form: FormGroup;

	constructor() {}

	get emails(): FormArray {
		return this.form.get('emails') as FormArray;
	}

	ngOnInit() {
		this.initForm();
	}

	initForm(): void {
		const emails = this.getEmailItems(this.data.options['emails']);
		this.form = new FormGroup({
			emails: new FormArray(emails.length ? emails : [this.createEmailControl()]),
		});
	}

	private getEmailItems(arr: string[]): FormGroup[] {
		return arr.map((email) => {
			return this.createEmailControl(email);
		});
	}

	public checkFormValid(form: FormGroup): boolean {
		const emailsArray = form.get('emails') as FormArray;
		const noEmptyEmails = emailsArray.controls.map((c: FormControl) => c.value.email).every((value) => !!value);

		return !!(noEmptyEmails && form.valid);
	}

	public updateValidation(arrayName, field): void {
		(this.form.get(arrayName) as FormArray).controls.forEach((group) => group.get(field).updateValueAndValidity());
	}

	private createEmailControl(value = ''): FormGroup {
		return new FormGroup({
			email: new FormControl(value, [Validators.email, duplicateControlError('email')]),
		});
	}

	onAddEmail(): void {
		const control = this.createEmailControl();
		this.emails.push(control);
	}

	onDeleteEmail(index: number): void {
		this.emails.removeAt(index);
	}

	onSubmit(): void {
		const options = {
			emails: this.emails.value.map((a) => a.email),
			type: this.data.options['type'],
			id: this.data.options['id'],
		};

		this.closeEvent(options);
	}

	closeEvent(e?: {}): void {}
}
